























































import { Mixins, Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import OzIcon from 'library/v4/components/oz-icon.vue'
import { IntlMixin } from 'vuemixins/intl_mixin'
import { Reaction } from '@padlet/arvo'

const reaction = namespace('reaction')
const snackbars = namespace('snackbars')

@Component({ components: { OzIcon } })
export default class SurfacePostReactionGradeNew extends Mixins(IntlMixin) {
  @Prop({ required: true }) canReact!: boolean
  @Prop({ required: true }) currentUserReacted!: boolean
  @Prop({ required: true }) myReactionId!: string | undefined
  @Prop({ required: true }) reactionCount!: number
  @Prop({ required: true }) reactionIds!: string[]
  @Prop({ required: true }) maxGrade!: number
  @Prop({ required: true }) isPadletColorSchemeDark!: boolean

  @reaction.Getter getReactionById!: (id) => Reaction | undefined
  @snackbars.Action setSnackbar!: (payload: { message: string }) => void

  get myReaction(): Reaction | undefined {
    return this.myReactionId ? this.getReactionById(this.myReactionId) : undefined
  }

  get myRating(): number {
    return this.myReaction ? this.myReaction.value : 0
  }

  get title(): string {
    if (this.reactionCount === 0) {
      return this.__('Be the first one to grade this post')
    }
    let title = this.__('Avg score: %{averageRating}', { averageRating: this.avgRating })
    if (this.myRating) {
      title += ' • ' + this.__('Your score: %{myRating}', { myRating: this.myRating })
    }
    return title
  }

  get sumRating(): number {
    const sumReducer = (sum: number, id): number => sum + (this.getReactionById(id) as Reaction).value
    return this.reactionIds.reduce(sumReducer, 0)
  }

  get avgRating(): number {
    return this.reactionCount === 0 ? 0 : Math.ceil(this.sumRating / this.reactionCount)
  }

  showReactionOffNotice(): void {
    const message = this.__('Reactions have been disabled by the admin.')
    this.setSnackbar({ message })
  }

  startReacting(): void {
    if (this.canReact) {
      this.$emit('edit')
    } else {
      this.showReactionOffNotice()
    }
  }
}
